import React, { Component } from "react";
import { useHistory } from "react-router-dom";
import Footer from "../../components/footer/Footer";
import TopButton from "../../components/topButton/TopButton";
import GalleryModal from "../../components/galleryModal/GalleryModal";
import { greeting, projectsHeader } from "../../portfolio.js";
import ProjectsData from "../../shared/opensource/projects.json";
import { galleryData } from "../../shared/galleryData";
import "./Projects.css";

function PhotoIcon() {
  return (
    <svg
      width="13"
      height="13"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
      <circle cx="8.5" cy="8.5" r="1.5" />
      <polyline points="21 15 16 10 5 21" />
    </svg>
  );
}

function hasRealUrl(url) {
  if (!url) return false;
  if (url === "https://github.com/Ghassen-Ben-Nasser") return false;
  return true;
}

function ProjectRow({ repo, index, theme, onGalleryOpen }) {
  const history = useHistory();
  const year = repo.createdAt.split("-")[0];
  const gallery = galleryData[repo.id] || [];
  const hasGallery = gallery.length > 0;
  const showLink = hasRealUrl(repo.url);

  function handleRowClick() {
    history.push(`/projects/${repo.id}`);
  }

  function openExternalLink(e) {
    e.stopPropagation();
    window.open(repo.url, "_blank");
  }

  function handleGalleryClick(e) {
    e.stopPropagation();
    onGalleryOpen(repo.id);
  }

  return (
    <div
      className="project-row"
      onClick={handleRowClick}
      style={{ borderColor: theme.text + "18" }}
    >
      <div className="project-row-inner">
        <span className="project-index" style={{ color: theme.secondaryText }}>
          {String(index + 1).padStart(2, "0")}
        </span>

        <div className="project-content">
          <div className="project-top">
            <h3 className="project-title" style={{ color: theme.text }}>
              {repo.name}
            </h3>
            <div className="project-meta">
              <span
                className="project-year"
                style={{ color: theme.secondaryText }}
              >
                {year}
              </span>
              {hasGallery && (
                <button
                  className="project-gallery-btn"
                  onClick={handleGalleryClick}
                  title="Quick view screenshots"
                  style={{
                    color: theme.imageHighlight,
                    borderColor: theme.imageHighlight + "40",
                    backgroundColor: theme.imageHighlight + "12",
                  }}
                >
                  <PhotoIcon />
                  <span>{gallery.length} photos</span>
                </button>
              )}
              {showLink && (
                <button
                  className="project-arrow"
                  onClick={openExternalLink}
                  title="Open project"
                  style={{ color: theme.secondaryText }}
                >
                  ↗
                </button>
              )}
            </div>
          </div>

          <p
            className="project-description"
            style={{ color: theme.secondaryText }}
          >
            {repo.description}
          </p>

          <div className="project-tags">
            {repo.languages.map((lang) => (
              <span
                key={lang.name}
                className="project-tag"
                style={{
                  color: theme.text,
                  borderColor: theme.text + "30",
                  backgroundColor: theme.text + "08",
                }}
              >
                {lang.name}
              </span>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

class Projects extends Component {
  constructor(props) {
    super(props);
    this.state = { quickViewId: null };
  }

  render() {
    const theme = this.props.theme;
    const { quickViewId } = this.state;
    const quickViewItems =
      quickViewId && galleryData[quickViewId] ? galleryData[quickViewId] : null;

    return (
      <div className="projects-main" style={{ backgroundColor: theme.body }}>
        <div className="projects-container">
          <div className="projects-header">
            <div className="projects-header-left">
              <p
                className="projects-label"
                style={{ color: theme.secondaryText }}
              >
                Selected Work
              </p>
              <h1 className="projects-title" style={{ color: theme.text }}>
                {projectsHeader.title}
              </h1>
            </div>
            <p className="projects-desc" style={{ color: theme.secondaryText }}>
              {projectsHeader.description}
            </p>
          </div>

          <div
            className="projects-divider"
            style={{ backgroundColor: theme.text + "18" }}
          />

          <div className="projects-list">
            {ProjectsData.data.map((repo, i) => (
              <ProjectRow
                key={repo.id}
                repo={repo}
                index={i}
                theme={theme}
                onGalleryOpen={(id) => this.setState({ quickViewId: id })}
              />
            ))}
          </div>

          <div className="projects-footer-link">
            <a
              href={greeting.githubProfile}
              target="_blank"
              rel="noopener noreferrer"
              className="projects-github-link"
              style={{ color: theme.text, borderColor: theme.text + "40" }}
            >
              View GitHub Profile ↗
            </a>
          </div>
        </div>

        {quickViewItems && (
          <GalleryModal
            items={quickViewItems}
            startIndex={0}
            onClose={() => this.setState({ quickViewId: null })}
          />
        )}

        <Footer theme={this.props.theme} onToggle={this.props.onToggle} />
        <TopButton theme={this.props.theme} />
      </div>
    );
  }
}

export default Projects;
